module.exports = __webpack_public_path__ + "static/media/la-depeche-du-midi.a88fde85.png";